import axios from '@/api/config';

const customerServiceSetting = {
  addCustomerServiceSetting(data) {
    return axios.post(`${process.env.BASE_URL}/customerServiceSetting/addCustomerServiceSetting`, data);
  },
  updateCustomerServiceSetting(data) {
    return axios.put(`${process.env.BASE_URL}/customerServiceSetting/updateCustomerServiceSetting`, data);
  },
  getCustomerServiceSetting(data) {
    return axios.get(`${process.env.BASE_URL}/customerServiceSetting/getCustomerServiceSetting`, {params:data});
  },
}

export default customerServiceSetting;



// WEBPACK FOOTER //
// ./src/api/customerServiceSetting.js